module.exports = __webpack_public_path__ + "resources/icon_50_share_black.db343974ec796d56.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_share_black.png
// module id = 437
// module chunks = 0 1 2 3 4